<template>
  <div class="tw-flex tw-items-center">
    <div class="tw-flex tw-flex-col fox-width-20">
      <span class="tw-font-bold tw-opacity-0">№</span>
      <span class="tw-py-1">{{ itemIndex + 1 }}.</span>
    </div>

    <div class="fox-invoice-item-row tw-flex tw-gap-2 tw-flex-wrap tw-flex-1">
      <div class="fox-width-200 tw-flex tw-flex-col">
        <span class="tw-font-bold">Beschreibung</span>
        <input
          v-model="invoiceItemLocal.description"
          type="text"
          class="fox-input--simple"
          v-bind:class="classes.description"
          @input="updateItem"
        >
      </div>

      <div class="fox-width-150 tw-flex tw-flex-col">
        <span class="tw-font-bold">Menge</span>
        <div class="tw-flex tw-gap-2">
          <AutoNumericInput
            class="fox-input--simple fox-width-80"
            v-model="invoiceItemLocal.quantity"
            :options="autonumericOptions.quantity"
            v-bind:class="classes.quantity"
            @input="updateItem"
          />

          <div class="tw-relative fox-width-70">
            <select v-model="invoiceItemLocal.unit" v-bind:class="classes.unit" class="fox-input--simple fox-input--simple-select tw-w-full" @change="updateItem">
              <option value disabled></option>
              <option value="piece">Stk</option>
              <option value="square_meter">m²</option>
              <option value="meter">m</option>
              <option value="kilogram">kg</option>
              <option value="tons">t</option>
              <option value="linear_meter">lfm</option>
              <option value="lump_sum">pauschal</option>
              <option value="cubic_meter">m³</option>
              <option value="hour">Std</option>
              <option value="kilometer">km</option>
              <option value="percentage">%</option>
              <option value="days">Tag(e)</option>
              <option value="liter">L</option>
            </select>

            <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="fox-width-120 tw-flex tw-flex-col">
        <span class="tw-font-bold">Einzelpreis</span>
        <AutoNumericInput
          class="fox-input--simple"
          v-model="invoiceItemLocal.unitPrice"
          :options="autonumericOptions.unitPrice"
          v-bind:class="classes.unitPrice"
          @input="updateItem"
        />
      </div>

      <div class="fox-width-100 tw-flex tw-flex-col">
        <span class="tw-font-bold">USt.</span>
        <div class="tw-flex tw-align-center tw-gap-2">
          <AutoNumericInput
            class="fox-input--simple fox-width-50"
            v-model="invoiceItemLocal.vatPercentage"
            :options="autonumericOptions.vatPercentage"
            v-bind:class="classes.vatPercentage"
            @input="updateItem"
          />
          <span class="fox-input--symbol-panel fox-width-30 tw-flex tw-items-center tw-justify-center">%</span>
        </div>
      </div>

      <div class="tw-flex-shrink-0 tw-whitespace-nowrap tw-self-center tw-py-2">
        {{ totalAmount }}
      </div>
    </div>

    <v-icon
      v-if="itemIndex > 0"
      color="gray darken-2"
      @click="removeItem"
      class="tw-ml-2"
    >
      mdi-trash-can-outline
    </v-icon>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AutoNumericInput from '@/components/Util/AutoNumericInput.vue'

export default {
  name: 'InvoiceItem',
  components: {
    AutoNumericInput
  },
  setup: () => ({ v$: useVuelidate() }),
  props: {
    invoiceItem: {
      type: Object
    },
    itemIndex: {
      type: Number
    }
  },
  data: function () {
    return {
      invoiceItemLocal: { ...this.invoiceItem },
      autonumericOptions: {
        quantity: {
          minimumValue: '0',
          decimalCharacter: ',',
          digitGroupSeparator: '',
          currencySymbol: ''
        },
        unitPrice: {
          minimumValue: '0',
          decimalCharacter: ',',
          digitGroupSeparator: '.',
          currencySymbol: ' €',
          currencySymbolPlacement: 's'
        },
        vatPercentage: {
          minimumValue: '0',
          maximumValue: '100',
          currencySymbol: '',
          decimalPlaces: 0
        }
      }
    }
  },
  validations () {
    return {
      invoiceItemLocal: {
        description: { required },
        quantity: { required },
        unit: { required },
        unitPrice: { required },
        vatPercentage: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        description: {
          'fox-input--error': this.v$.invoiceItemLocal.description.$error
        },
        quantity: {
          'fox-input--error': this.v$.invoiceItemLocal.quantity.$error
        },
        unit: {
          'fox-input--error': this.v$.invoiceItemLocal.unit.$error
        },
        unitPrice: {
          'fox-input--error': this.v$.invoiceItemLocal.unitPrice.$error
        },
        vatPercentage: {
          'fox-input--error': this.v$.invoiceItemLocal.vatPercentage.$error
        }
      }
    },
    totalAmount () {
      let grossAmountFactor = null
      let total = null

      if (this.invoiceItemLocal.vatPercentage) {
        grossAmountFactor = 1 + this.invoiceItemLocal.vatPercentage / 100
      }

      if (this.invoiceItemLocal.quantity && this.invoiceItemLocal.unitPrice) {
        total = this.invoiceItemLocal.quantity * this.invoiceItemLocal.unitPrice
      }

      if (grossAmountFactor) {
        total = total * grossAmountFactor
      }

      if (!total) {
        return null
      }

      return total.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
    }
  },
  watch: {
    invoiceItem: {
      handler(newVal) {
        this.invoiceItemLocal = { ...newVal }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateItem () {
      this.$emit('updateItem', this.invoiceItemLocal, this.itemIndex)
    },
    removeItem () {
      this.$emit('removeItem', this.itemIndex)
    }
  }
}
</script>

<style scoped>

</style>
